
const screens = {
  state: {
    getDate: '', // 判断历史时间还是实时数据
    screenOrg: '', // 机构筛选
    riskType: '', // 类型筛选
    reachStart: '', // 达成范围起
    reachEnd: '', // 达成范围止
    proportionStrat: '', // 占比范围起
    proportionEnd: '', // 占比范围止
    saleProduct: '', // 主销产品
    period: '', // 年期
    TopHundred: '', // 百强中支
    checkedArea: ''
  },
  mutations: {
    // 机构筛选
    SCREENS_SET_SCREENORG: (state, type) => {
      state.screenOrg = type
    },
    // 类型筛选
    SCREENS_SET_RISKTYPE: (state, type) => {
      state.riskType = type
    },
    // 达成范围起
    SCREENS_SET_REACHSTART: (state, type) => {
      state.reachStart = type
    },
    // 达成范围止
    SCREENS_SET_REACHEND: (state, type) => {
      state.reachEnd = type
    },
    // 占比范围起
    SCREENS_SET_PROPORTIONSTRAT: (state, type) => {
      state.proportionStrat = type
    },
    // 占比范围止
    SCREENS_SET_PROPORTIONEND: (state, type) => {
      state.proportionEnd = type
    },
    // 主销产品
    SCREENS_SET_SALEPRODUCT: (state, type) => {
      state.saleProduct = type
    },
    SCREENS_SET_CHECKEDAREA: (state, type) => {
      state.checkedArea = type
    },
    // 年期
    SCREENS_SET_PERIOD: (state, type) => {
      state.period = type
    },
    // 判断机构传来的是否是百强中支
    SCREENS_SET_TOPHUNDRED: (state, type) => {
      state.TopHundred = type
    }
  }
}
export default screens



// WEBPACK FOOTER //
// ./src/store/modules/screens.js